module.exports = __webpack_public_path__ + "static/media/109.26b83b7f.jpg";